<template>
  <div class="register">
    <div>
      <re-header></re-header>
    </div>
    <div class="form-part">
      <el-row :gutter="20">
        <el-col :span="24">
          <div>
            <el-card :body-style="{ padding: '0px' }">
              <h1>国家智能农机装备产业技术创新战略联盟用户注册</h1>
              <div class="form-cup">
                <el-form ref="form" :model="form" :rules="dataRule" @keyup.enter.native="onRegist" status-icon>
                  <el-form-item prop="userName">
                    <el-col :span="2">
                      <span class="el-icon-user icon-size"></span>
                    </el-col>
                    <el-col :span="22">
                      <el-input v-model="form.userName" placeholder="请输入用户名" style="width:80%;"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item>
                    <el-col :span="2">
                      <span class="el-icon-user icon-size"></span>
                    </el-col>
                    <el-col :span="22">
                      <el-input v-model="form.realName" placeholder="请输入真实姓名" style="width:80%;"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item prop="phone">
                    <el-col :span="2">
                      <span class="el-icon-mobile-phone icon-size"></span>
                    </el-col>
                    <el-col :span="22">
                      <el-input v-model="form.phone" placeholder="请输入手机号" style="width:80%;" auto-complete="on">
                      </el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item prop="code">
                    <el-col :span="2">
                      <span class="el-icon-lock icon-size"></span>
                    </el-col>
                    <el-col :span="22">
                      <el-input v-model="form.code" placeholder="请输入密码" :type="pwdType" style="width:80%;"
                        auto-complete="on"></el-input>
                    </el-col>
                    <!-- <el-col :span="2">
                      <span class="show-pwd" @click="showPwd">
                        <svg-icon :icon-class="pwdType === 'password' ? 'eye' : 'eye-open'" />
                      </span>
                    </el-col> -->
                  </el-form-item>
                  <el-form-item prop="recode">
                    <el-col :span="2">
                      <span class="el-icon-lock icon-size"></span>
                    </el-col>
                    <el-col :span="22">
                      <el-input v-model="form.recode" placeholder="请确认密码" :type="pwdType" style="width:80%;"
                        auto-complete="on"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item v-show="iscode">
                    <el-col :span="2"> &nbsp; </el-col>
                    <el-col :span="22" class="warnTip"> {{pwdtip}} </el-col>
                  </el-form-item>
                  <el-form-item>
                    <el-col :span="6">
                      &nbsp;
                    </el-col>
                    <el-col :span="18">
                      <el-button type="primary" @click="onRegist" style="width:50%">提交</el-button>
                    </el-col>
                  </el-form-item>
                </el-form>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>
    <div>
      <mod-footer></mod-footer>
    </div>
  </div>
</template>
<script>
import reHeader from './reHeader';
import modFooter from './footer';
import { register } from '@/api/register';
export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'));
      } else {
        callback();
      }
    };
    const validataRePass = (rule, value, callback) => {
      if (value !== this.form.code) {
        callback(new Error('确认输入相同密码'));
      } else {
        callback();
      }
    };
    const validataPhone = (rule, value, callback) => {
      let phoneReg = /^1[3-9][0-9]\d{8}$/;
      if (!phoneReg.test(value)) {
        callback(new Error('确认输入正确格式的手机号码'));
      } else {
        callback();
      }
    };
    return {
      form: {
        userName: '',
        phone: '',
        code: '',
        recode: '',
        realName: ''
      },
      iscode: false,
      pwdtip: '',
      pwdType: 'password',
      dataRule: {
        userName: [
          {
            required: true,
            message: '帐号不能为空',
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: '密码不能为空',
            trigger: 'blur'
          },
          {
            required: true,
            trigger: 'change',
            validator: validatePass
          },
          {
            required: true,
            trigger: 'blur',
            validator: validatePass
          }
        ],
        recode: [
          {
            required: true,
            trigger: 'blur',
            validator: validataRePass
          }
        ],
        phone: [
          {
            required: true,
            trigger: 'blur',
            validator: validataPhone
          }
        ]
      }
    };
  },
  components: {
    reHeader,
    modFooter
  },
  methods: {
    onRegist() {
      let reSelf = this;
      register({
        userName: reSelf.form.userName,
        phone: reSelf.form.phone,
        password: reSelf.form.code,
        realName: reSelf.form.realName
      }).then(res => {
        if (res.result.code === 0) {
          reSelf.$router.push({ path: 'home' });
        }
      });
    },
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = '';
      } else {
        this.pwdType = 'password';
      }
    }
  }
};
</script>
<style  scoped>
.register {
  width: 100%;
  height: 100%;
}

.form-part {
  width: 50%;
  margin: 20px auto;
  min-height: 470px;
}

.form-cup {
  padding: 10px;
  width: 50%;
  margin: 0 auto;
}

h1 {
  width: 70%;
  margin: 10px auto;
}

.icon-size {
  font-size: 22px;
}

.warnTip {
  color: #f56c6c;
}

/* .show-pwd {
  position: absolute;
  right: 10px;
  top: 7px;
  font-size: 16px;
  color: $dark_gray;
  cursor: pointer;
  user-select: none;
} */
</style>



// WEBPACK FOOTER //
// src/common/area/register.vue